/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'coloring-slider-house': {
    width: 44,
    height: 44,
    viewBox: '0 0 44 44',
    data: `<defs><clipPath id="svgicon_coloring-slider-house_a"><path pid="0" d="M0 0h44v44H0z"/></clipPath></defs><g clip-path="url(#svgicon_coloring-slider-house_a)"><path pid="1" d="M33.774 16.78v-6.745h-2.9v3.841l-8.378-8.378L8.533 19.461v19.254h27.926V19.463z" _fill="none" _stroke="#000" stroke-miterlimit="10"/></g>`
  }
})
/* tslint:enable */
